// extracted by mini-css-extract-plugin
export default {"wrapper":"JR-z","firstToReview":"KR-z","productCards":"LR-z","productCard":"MR-z","stars":"NR-z","hidden":"OR-z"};